import './styles/maintenance-templates-toolbar.scss'

import React     from 'react'
import PropTypes from 'prop-types'

import { Button } from 'semantic-ui-react'

export default class MaintenanceTemplatesToolbar extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  }

  handleNew = () => {
    this.props.history.push('/maintenance-templates/item/new')
  }

  render() {
    return (
      <div className="maintenance-templates-toolbar">
        <Button primary onClick={this.handleNew}>New Maintenance Template</Button>
      </div>
    )
  }
}